import { matchPath, useLocation } from 'react-router-dom';

const CANDIDATES_PATTERNS = [
  '/customers/:customerId?/candidates',
  '/candidates',
];
const JOBS_PATTERNS = ['/', '/customers/:customerId?'];

export const useHomepageRouteMatch = () => {
  const { pathname } = useLocation();

  const isHomepageCandidatesPage = CANDIDATES_PATTERNS.some(pattern =>
    matchPath({ path: pattern, end: true }, pathname),
  );

  const isHomepageJobsPage = JOBS_PATTERNS.some(pattern =>
    matchPath({ path: pattern, end: true }, pathname),
  );

  const isHomepage = isHomepageJobsPage || isHomepageCandidatesPage;

  return { isHomepageJobsPage, isHomepageCandidatesPage, isHomepage };
};
